import React from "react";

function WhyCSmartContract() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer Technology for Your Smart Contract Needs?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  With extensive experience and a dedicated focus on security,
                  Xeer Technology is a trusted partner for smart contract
                  development and auditing. We are committed to delivering
                  cutting-edge blockchain solutions that prioritize your
                  project’s integrity, performance, and user experience.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyCSmartContract;
